export default __webpack_public_path__ + "static/media/048-louvre.6fb89926.svg";